
import { defineComponent } from 'vue';

import { Field } from '@/modules/CreateServiceContract/helpers/Fields.interface';
import FieldsComponent from '@/components/layout/Fields.vue'
export default defineComponent({
    components: {
        FieldsComponent,
    },
    props: {
        id: {
            type: Number, 
            required: true
        }, 
        agreementID: {
            type: String, 
            required: false
        }, 
        taskID: {
            type: String, 
            required: false
        }
    },
    async mounted() { 
        await this.getFields();
        const field = this.fields.find(field => field.id === 'ServiceAgreement.ServiceAgreementID')
        if (field) {
            const currentRoute = this.$router.currentRoute.value; 
            let currentId = currentRoute.params.id; 
            if (
                currentRoute.name == 'customer_lookup_view' &&
                !Array.isArray(currentRoute.params.id) && 
                currentRoute.params.id == String(this.id) &&
                currentRoute.params.step == 'ContractInfo' &&
                currentRoute.params.agreementID == field.value
            ) return;
            this.$router.replace({ name: 'customer_lookup_view', params: { id: this.id, step: 'ContractInfo', agreementID: String(field.value) } })
        }
    },
    computed: {
        config: function () {
            let url : string = "customerlookup/fields/service-agreement/" + this.id;
            if (this.agreementID) {
                url += "/" + this.agreementID;
            }
            return {
                url,
                method: 'get',
            }
        }
    },

    watch: {
        async config() { 
            await this.getFields();
        }
    },
    data: function () {
        return {
            loading: true, 
            fields: [] as Field[], 
            contractId: null
        }
    }, 
    methods: {
        async getFields() { 
            this.loading = true;
            try { 
                const response = await this.$root?.$data.API.request(this.config)
                this.fields = response.data;
            } catch (error) {
                this.loading = true;
            }
            this.loading = false;
            
        }, 
        async fieldUpdated(field: any) { 
            if (field.id === 'ServiceAgreement.ServiceAgreementID') {
                const currentRoute = this.$router.currentRoute.value; 
                let currentId = currentRoute.params.id; 
                if (
                    currentRoute.name == 'customer_lookup_view' &&
                    !Array.isArray(currentRoute.params.id) && 
                    currentRoute.params.id == String(this.id) &&
                    currentRoute.params.step == 'ContractInfo' &&
                    currentRoute.params.agreementID == field.value
                ) return;
                this.$router.push({ name: 'customer_lookup_view', params: { id: this.id, step: 'ContractInfo', agreementID: field.value } })
            }
        }
    }
});
